import { render, staticRenderFns } from "./inProduction.vue?vue&type=template&id=40845f5a&scoped=true"
import script from "./inProduction.vue?vue&type=script&lang=js"
export * from "./inProduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40845f5a",
  null
  
)

export default component.exports